import { atom } from 'jotai/index';

// TODO_R: [FAR]
export const addressAtom = atom<string | null>(null);
